export default {"src":"/_next/static/media/zucchini.404eb3e4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};